import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, throwError, of} from 'rxjs';
import {map, tap, catchError, take, defaultIfEmpty} from 'rxjs/operators';
import {SeoService_Generic, LanguageService} from '@signature-it/ngx-generic/services';
import {SEODTO} from '@signature-it/ngx-generic/models';
import {ILanguage} from  '@signature-it/ngx-generic/interfaces';
import { GenericConfig } from '@signature-it/ngx-generic/config';

@Injectable({
    providedIn: 'root'
})
export class SEOResolver  {
    constructor(private router: Router,
                private seoSvc: SeoService_Generic,
                private langSvc: LanguageService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
        if (!GenericConfig.disableSeo) {
			this.langSvc
				.languageSelected$
				.subscribe((lang: ILanguage) => {
                if (lang) {
                    this.seoSvc.getSeo(state.url, lang.id).pipe(take(2)).subscribe((seo: SEODTO) => {
                        if(seo){
                            this.seoSvc.setSeo(seo.title, seo.description);
                        }
                    });
                }
            });
        }
        return of().pipe(defaultIfEmpty(false));
    }
}
